import { CdkScrollable } from '@angular/cdk/scrolling';
import { DatePipe } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule, UntypedFormControl, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { DateAdapter } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule, MatSuffix } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { UserService } from 'src/app/services/user.service';

import { editorConfig } from '../../models/editorconfig';
import { EditorComponent } from '../editor/editor.component';

@Component({
  selector: 'app-prolongation-decision',
  templateUrl: './prolongation-decision.component.html',
  styleUrls: ['./prolongation-decision.component.scss'],
  imports: [
    EditorComponent,
    MatDialogModule,
    CdkScrollable,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatButtonToggleModule,
    CKEditorModule,
    MatDatepickerModule,
    MatSuffix,
    DatePipe
  ],
  providers: [DatePipe]
})
export class ProlongationDecisionComponent implements OnInit {
  data = inject(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<ProlongationDecisionComponent>>(MatDialogRef);
  private _adapter = inject<DateAdapter<unknown>>(DateAdapter);
  userService = inject(UserService);

  form!: FormGroup;
  showOtherDate = false;
  userDominoName!: string;
  tabSelect = 0;
  shortRemarkEditor = ClassicEditor;
  editorConfig = {};

  ngOnInit() {
    this.editorConfig = editorConfig.standard;
    this.initForm();
  }

  initForm() {
    this.form = this.data.formGroup;
    this._adapter.setLocale('de');
  }

  showDateField() {
    return this.showOtherDate;
  }

  selectedTab(tabindex: string) {
    this.tabSelect = parseInt(tabindex, 10);
    if (this.tabSelect === 1) {
      this.showOtherDate = true;
      this.data.formGroup.controls['prolongationOtherDate'].setValue(this.data.formGroup?.value.prolongationDeadline);
    } else {
      this.showOtherDate = false;
      this.data.formGroup.controls['prolongationOtherDate'].setValue('');
    }
  }

  setChoice() {
    this.form.controls['prolongationGrantedDate'].setValue(new Date());
    switch (this.tabSelect) {
      case 0: {
        this.grantAsRequested();
        this.closeDialog();
        break;
      }
      case 1: {
        this.grantOtherDate();
        break;
      }
      case 2: {
        this.reject();
        break;
      }
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  grantAsRequested() {
    const otherDate = this.form.get('prolongationOtherDate');
    if (otherDate) {
      otherDate.clearValidators();
      this.data.formGroup.controls['prolongationStatus'].setValue('Granted');
      this.data.formGroup.controls['prolongationDecision'].setValue('1');
      this.data.formGroup.controls['prolongationOtherDate'].setValue('');
      this.data.formGroup.controls['currentDeadlineDate'].setValue(
        this.data.formGroup.get('prolongationDeadline')?.value
      );
      this.data.formGroup.addControl('current_prolongationStatus', new UntypedFormControl('Granted'));
      this.grantedSignature();
    }
  }

  grantOtherDate() {
    if (this.otherDateInvalid()) {
      return;
    }
    this.data.formGroup.controls['prolongationStatus'].setValue('Granted');
    this.data.formGroup.controls['prolongationDecision'].setValue('2');
    this.data.formGroup.controls['currentDeadlineDate'].setValue(this.data.formGroup?.value.prolongationOtherDate);
    this.data.formGroup.addControl('current_prolongationStatus', new UntypedFormControl('Granted'));
    this.grantedSignature();
    this.closeDialog();
  }

  otherDateInvalid(): boolean {
    let isInvalid = true;
    const otherDate = this.form.get('prolongationOtherDate');
    if (otherDate) {
      otherDate.setValidators([Validators.required]);
      otherDate.updateValueAndValidity();
      isInvalid = otherDate.status === 'INVALID';
    }
    return isInvalid;
  }

  reject(): void {
    const otherDate = this.form.get('prolongationOtherDate');
    if (otherDate) {
      otherDate.clearValidators();
      this.showOtherDate = false;
      this.data.formGroup.addControl('current_prolongationStatus', new UntypedFormControl('Rejected'));
      this.data.formGroup.controls['prolongationStatus'].setValue('Rejected');
      this.data.formGroup.controls['prolongationDecision'].setValue('0');
      this.data.formGroup.controls['prolongationOtherDate'].setValue('');
      this.data.formGroup.controls['shortRemarkToAssessor'].setValue(this.form.get('shortRemarkToAssessor')?.value);
      this.grantedSignature();
    }
  }

  grantedSignature() {
    //this.userDominoName = this.userService.userProfile().id;
    this.form.controls['prolongationGrantedBy'].setValue(this.userDominoName);
  }
}
